import { render, staticRenderFns } from "./GlobalSearchMobile.vue?vue&type=template&id=487a62e2&scoped=true"
import script from "./GlobalSearchMobile.vue?vue&type=script&lang=js"
export * from "./GlobalSearchMobile.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchMobile.vue?vue&type=style&index=0&id=487a62e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a62e2",
  null
  
)

export default component.exports